import { gql } from '@apollo/client/core';

export const createBillingAccount = gql`
  mutation createBillingAccount($data: BillingAccountCreateInput!) {
    createBillingAccount(data: $data) {
      id
      name
      cif
      city
      zipCode
      countryCode
      fiscalAddress
      Partner {
        id
        name
        orgCode
      }
    }
  }
`;
